<div class="custom-container">
  <div class="row justify-content-center">
    <div class="col-lg-5 d-flex align-items-center justify-content-center">
      <div class="wrapper">
        <div class="card-body">
          <div class="wrapper">
            <div class="content">
              <img
                width="100"
                src="./assets/icons/ic-success.svg"
                alt="success"
              />

              <span class="text-center">
                <p class="message-type">Senha criada com sucesso</p>
                <p class="text mt-4">
                  Agora, <b>baixe o aplicativo e instale</b>, de acordo com a
                  plataforma do seu celular.

                  <br />
                  <br />
                  Abra <b>no seu celular</b> um dos links abaixo de acordo com o
                  modelo:
                </p>

                <div class="button-group d-flex flex-column gap-4">
                  <app-black-button
                    [showIcon]="true"
                    class="mt-4"
                    iconSize="28"
                    iconName="bootstrapAndroid2"
                    buttonText="Caso seu celular seja Android"
                  ></app-black-button>
                  <app-black-button
                    [showIcon]="true"
                    iconSize="28"
                    class="mt-2"
                    iconName="bootstrapApple"
                    buttonText="Caso seu celular seja Iphone"
                  ></app-black-button>
                </div>

                <div class="advice-wrapper mt-4">
                  <p class="advice">
                    Após instalar o aplicativo, basta entrar com seu <br />
                    e-mail e com essa senha que você acabou de criar.
                  </p>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 slider">
      <app-slider></app-slider>
    </div>
  </div>
</div>
